import * as React from 'react';

import { TextArea } from '../../components/forms';
import { Button } from '../../components/buttons';

interface Props {
	className?: string;
	note: CustomerNote;
	onChange: (e: any) => void;
	onSave: () => void;
}
const CustomerNoteDetailsForm: React.StatelessComponent<Props> = props => {
	return (
		<div className={props.className}>
			<h2 className="form-fieldset-title">{props.note.id ? 'Update note' : 'Add a note'}</h2>
			<div className="form-fieldset">
				<div className="row">
					<TextArea
						labelText="Notes"
						name="notes"
						onChange={props.onChange}
						value={props.note.notes}
						className="col-md-12"
					/>
				</div>
				<Button onClick={props.onSave} className="btn-primary mt-4" >Save</Button>
			</div>
		</div>
	);
};

export default CustomerNoteDetailsForm;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/admin/customers/CustomerNoteDetailsForm.tsx